import Vue from "vue";
import Router from "vue-router";

import Login from "@/views/auth/login";
// import Register from '@/views/auth/register'
import ResetPassword from "@/views/auth/reset";
import CompleteReset from "@/views/redirect/index";

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/login",
    },
    {
      name: "login",
      path: "/login",
      component: Login,
    },
    // {
    //     name: 'register',
    //     path: '/register',
    //     component: Register
    // },
    {
      name: "reset",
      path: "/password-reset",
      component: ResetPassword,
    },
    {
      name: "completereset",
      path: "/complete-reset",
      component: CompleteReset,
    },
    {
      path: "/dashboard",
      component: () => import("@/views/dashboard/index"),
      redirect: "/dashboard/overview",
      children: [
        {
          name: "overview",
          path: "overview",
          component: () => import("@/views/dashboard/overview/index"),
        },
        {
          name: "blacklists-list",
          path: "blacklists/approved",
          component: () => import("@/views/dashboard/blacklists/list"),
        },
        {
          name: "blacklists-pending-list",
          path: "blacklists/pending",
          component: () => import("@/views/dashboard/blacklists/pendinglist"),
        },
        {
          name: "blacklists-upload",
          path: "blacklists/upload",
          component: () => import("@/views/dashboard/blacklists/bulkUpload"),
        },
        {
          name: "transaction-list",
          path: "transactions",
          component: () => import("@/views/dashboard/transactions/list"),
        },
        {
          name: "bills-payment-list",
          path: "bills-payment",
          component: () => import("@/views/dashboard/bills-payment/list"),
        },
        {
          name: "transaction-details",
          path: "transactions/:id",
          component: () => import("@/views/dashboard/transactions/details"),
        },
        {
          name: "view-payout-dashboard",
          path: "payouts",
          component: () => import("@/views/dashboard/new-payouts"),
        },
        {
          name: "view-payout-dashboard-summaries",
          path: "payout/summaries",
          component: () => import("@/views/dashboard/new-payouts"),
        },
        {
          name: "view-payout-dashboard-funding",
          path: "payout/funding",
          component: () => import("@/views/dashboard/new-payouts"),
        },
        {
          name: "view-accounts",
          path: "accounts/:id",
          component: () => import("@/views/dashboard/Account/Account.vue"),
        },
        {
          name: "view-reserved-accounts",
          path: "accounts/reserved/:id",
          component: () =>
            import("@/views/dashboard/Account/ViewReservedAccountDetails"),
          children: [
            {
              name: "funding",
              path: "funding",
              component: () =>
                import("@/views/dashboard/Account/ViewReservedAccountDetails"),
            },
          ],
        },

        {
          name: "view-payout-details",
          path: "payouts/:id",
          component: () => import("@/views/dashboard/payouts/payoutdetails"),
        },
        {
          name: "view-payout-single-details",
          path: "payouts/:id/merchants/:reference",
          component: () =>
            import("@/views/dashboard/payouts/singlepayoutdetails.vue"),
        },
        {
          name: "view-funding-details",
          path: "payouts/fundinghistory/:id",
          component: () => import("@/views/dashboard/payouts/payoutdetails"),
        },
        {
          name: "mandate-list",
          path: "mandates",
          component: () => import("@/views/dashboard/mandates/list"),
        },
        {
          name: "mandate-details",
          path: "mandates/:id",
          component: () => import("@/views/dashboard/mandates/details"),
        },
        {
          name: "merchants-list",
          path: "merchants",
          component: () => import("@/views/dashboard/merchants/list"),
        },
        {
          name: "merchants-details",
          path: "merchants/:id",
          component: () => import("@/views/dashboard/merchants/details"),
        },
        {
          name: "create-merchant",
          path: "merchant/create",
          component: () => import("@/views/dashboard/merchants/createmerchant"),
        },
        {
          name: "merchant-links",
          path: "merchant/links/:id",
          component: () => import("@/views/dashboard/merchants/paymentlinks"),
        },
        {
          name: "merchant-kyc-review",
          path: "merchant/:id/kyc",
          component: () => import("@/views/dashboard/review-kyc/list"),
        },
        {
          name: "merchant-edit",
          path: "merchants/:id/edit",
          component: () => import("@/views/dashboard/merchants/edit/index"),
          redirect: { name: "merchant-edit-details" },
          children: [
            {
              name: "merchant-edit-details",
              path: "details",
              component: () =>
                import("@/views/dashboard/merchants/edit/editmerchant"),
            },
            {
              name: "merchant-edit-fee",
              path: "create",
              component: () => import("@/views/dashboard/merchants/edit/fee"),
            },
            {
              name: "merchant-fee-add",
              path: "fee/add",
              component: () =>
                import("@/views/dashboard/merchants/edit/editaddfee"),
            },
            {
              name: "merchant-fee-edit",
              path: "fee/edit/:feeId",
              component: () =>
                import("@/views/dashboard/merchants/edit/editaddfee"),
            },
            {
              name: "merchant-list-fee",
              path: "fee",
              component: () =>
                import("@/views/dashboard/merchants/edit/feelist"),
            },
            {
              name: "merchant-routing-rule",
              path: "routingrules",
              component: () =>
                import("@/views/dashboard/merchants/edit/routingrules"),
            },
            {
              name: "direct-debit-edit-rule",
              path: "directdebit/edit/:itemId",
              component: () =>
                import("@/views/dashboard/settings/directdebiteditrule"),
            },
            {
              name: "modify-merchant-routine-rule",
              path: "routingrules/specific",
              component: () =>
                import("@/views/dashboard/merchants/edit/routingrulespecific"),
            },
            {
              name: "merchant-edit-direct-debit",
              path: "directdebit",
              component: () =>
                import("@/views/dashboard/merchants/edit/directdebit"),
            },
            {
              name: "merchant-edit-access-control",
              path: "accesscontrol",
              component: () =>
                import("@/views/dashboard/merchants/edit/accesscontrol"),
            },
          ],
        },
        {
          name: "users-list",
          path: "users",
          component: () => import("@/views/dashboard/users/list"),
        },
        {
          name: "create-users",
          path: "users/create",
          component: () => import("@/views/dashboard/users/create"),
        },
        {
          name: "update-user",
          path: "users/update/:id",
          component: () => import("@/views/dashboard/users/update"),
        },
        {
          name: "customers-list",
          path: "customers",
          component: () => import("@/views/dashboard/customers/list"),
        },
        {
          name: "customers-details",
          path: "customers/:id",
          component: () => import("@/views/dashboard/customers/details"),
        },
        {
          name: "settlements-list-details",
          path: "settlements/details/:id",
          component: () => import("@/views/dashboard/settlements/details"),
        },
        {
          name: "unsettled-list-details",
          path: "settlements/unsettled/details/:id",
          component: () =>
            import("@/views/dashboard/settlements/transactionDetails"),
        },
        {
          name: "settlements-list-details-batch",
          path: "settlements/batch/details/:id/:type",
          component: () => import("@/views/dashboard/settlements/batch"),
        },
        {
          name: "settlements-list-details-type",
          path: "settlements/details/:id/:type",
          component: () => import("@/views/dashboard/settlements/details"),
        },
        {
          name: "settlements-transactions",
          path: "settlements/transactions",
          component: () => import("@/views/dashboard/settlements/transactions"),
        },
        {
          name: "settlements-list",
          path: "settlements/:type",
          component: () => import("@/views/dashboard/settlements/list"),
        },
        {
          name: "audit",
          path: "audittrail",
          component: () => import("@/views/dashboard/audit/list"),
        },
        {
          name: "lien",
          path: "lien",
          component: () => import("@/views/dashboard/lien/list"),
        },
        {
          name: "banks",
          path: "banks",
          component: () => import("@/views/dashboard/banks/list"),
        },
        {
          name: "banks-details",
          path: "banks/:id",
          component: () => import("@/views/dashboard/banks/details"),
        },
        {
          name: "transfers-list",
          path: "transfers",
          component: () => import("@/views/dashboard/transfers/index"),
        },
        {
          name: "transfers-initiate",
          path: "transfers/initiate",
          component: () => import("@/views/dashboard/transfers/initiate"),
        },
        {
          name: "transfers-details",
          path: "transfers/:reference",
          component: () => import("@/views/dashboard/transfers/details"),
        },
        {
          name: "statements",
          path: "statements",
          component: () => import("@/views/dashboard/statements"),
          redirect: "/dashboard/statements/overview",
          children: [
            {
              name: "statements-list",
              path: "overview",
              component: () => import("@/views/dashboard/statements/list"),
            },
            {
              name: "uploadHistory",
              path: "upload-history",
              component: () =>
                import("@/views/dashboard/statements/upload-history"),
            },
            {
              name: "createSingleStatement",
              path: "create-single",
              component: () =>
                import("@/views/dashboard/statements/create-statement"),
            },
            {
              name: "createBulkStatement",
              path: "create-bulk",
              component: () =>
                import("@/views/dashboard/statements/create-statement"),
            },
          ],
        },
        {
          name: "Priority Configuration",
          path: "priority-config",
          component: () => import("@/views/dashboard/priority-config/index"),
        },
        {
          name: "settings",
          path: "settings",
          component: () => import("@/views/dashboard/settings/index"),
          redirect: "/dashboard/settings/profile",
          children: [
            {
              name: "settings-profile",
              path: "profile",
              component: () => import("@/views/dashboard/settings/profile"),
            },
            // {
            //     name: 'settings-business',
            //     path: 'business',
            //     component: () => import('@/views/dashboard/settings/businessinformation')
            // },
            {
              name: "modify-routine-rules",
              path: "routingrules/edit",
              component: () =>
                import("@/views/dashboard/settings/routingrulesedit"),
            },
            {
              name: "default-routine-rules",
              path: "routingrules/default",
              component: () =>
                import("@/views/dashboard/settings/defaultroutingrules"),
            },
            {
              name: "routine-rules",
              path: "routingrules",
              component: () =>
                import("@/views/dashboard/settings/routingrules"),
            },
            {
              name: "settings-fee-add",
              path: "fee/add",
              component: () => import("@/views/dashboard/settings/add-bank-fee"),
            },
            {
              name: "settings-fee-edit",
              path: "fee/edit/:id",
              component: () => import("@/views/dashboard/settings/add-bank-fee"),
            },
            {
              name: "settings-fee",
              path: "fee",
              component: () => import("@/views/dashboard/settings/fee"),
            },
            {
              name: "settings-password",
              path: "password",
              component: () => import("@/views/dashboard/settings/password"),
            },
            {
              name: "settings-direct-debit",
              path: "directdebit",
              component: () =>
                import("@/views/dashboard/settings/directdebitrule"),
            },
            {
              name: "settings-bills-payment",
              path: "bills-payment",
              component: () =>
                import("@/views/dashboard/settings/bills-payment"),
            },
            {
              name: "settings-authentication",
              path: "authentication",
              component: () =>
                import("@/views/dashboard/settings/authentication"),
            },
            {
              name: "global-direct-debit-edit-rule",
              path: "directdebit/edit/:itemId",
              component: () =>
                import("@/views/dashboard/settings/directdebiteditrule"),
            },
            {
              name: "priority-configuration",
              path: "priority-config",
              component: () =>
                import("@/views/dashboard/settings/priority-config"),
            },
            // {
            //     name: 'settings-api',
            //     path: 'apikeys',
            //     component: () => import('@/views/dashboard/settings/apikey')
            // },
            // {
            //     name: 'settings-preference',
            //     path: 'preference',
            //     component: () => import('@/views/dashboard/settings/preference')
            // },
          ],
        },
      ],
    },
    {
      path: "*",
      name: "not-found",
      redirect: "/login",
    },
  ],
});
